/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  Grid,
  TextField,
  Text,
  View,
  PhoneNumberField,
} from "@aws-amplify/ui-react";
import { getOverrideProps } from "@aws-amplify/ui-react/internal";
import { Leads } from "../models";
import { DataStore } from "aws-amplify";
import TableDetail from "./TableDetail";

export default function FormDetailLead(props) {
  const {
    id: idProp,
    leads,
    clearOnSuccess = true,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    onToggleTab,
    ...rest
  } = props;
  
  const initialValues = {
    name: "",
    firstLastName: "",
    secondLastName: "",
    phone1: "",
    birth: "",
    adress:"",
    cp: "",
    suburb: "",
    curp: "",
    email: "",
  };
  
  const [name, setName] = React.useState(initialValues.name);
  const [firstLastName, setFirstLastName] = React.useState(
    initialValues.firstLastName
  );
  const [secondLastName, setSecondLastName] = React.useState(
    initialValues.secondLastName
  );
  const [phone, setPhone] = React.useState(initialValues.phone1);
  const [birth, setBirth] = React.useState(initialValues.birth);
  const [cp, setCp] = React.useState(initialValues.cp);
  const [suburb, setSuburb] = React.useState(initialValues.suburb);

  const [curp, setCurp] = React.useState(initialValues.curp);
  const [email, setEmail] = React.useState(initialValues.email);
  const [adress, setAdress] = React.useState(initialValues.adress);

  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    const cleanValues = leadsRecord
      ? { ...initialValues, ...leadsRecord }
      : initialValues;
    setName(cleanValues.name);
    setFirstLastName(cleanValues.firstLastName);
    setSecondLastName(cleanValues.secondLastName);
    setPhone(cleanValues.phone1);
    setBirth(cleanValues.birth);
    setAdress(cleanValues.adress)
    setCp(cleanValues.adress?.cp);
    setSuburb(cleanValues.adress?.asentamiento);
    setCurp(cleanValues.curp);
    setEmail(cleanValues.email);
    setErrors({});
  };
  const [leadsRecord, setLeadsRecord] = React.useState(leads);
  React.useEffect(() => {
    const queryData = async () => {
      const record = idProp ? await DataStore.query(Leads, idProp) : leads;
      setLeadsRecord(record);
    };
    queryData();
  }, [idProp, leads]);
  React.useEffect(resetStateValues, [leadsRecord]);

 // console.log(adress)
  return (
    <Grid
      as="form"
      rowGap="32px"
      columnGap="24px"
      templateColumns={{
        base: "1fr",
        small: "1fr 1fr 1fr",
        medium: "1fr 1fr 1fr 1fr",
      }}
      padding="20px"
      onSubmit=""
      {...getOverrideProps(overrides, "LeadsUpdateForm")}
      {...rest}
    >
      <View columnStart="1" columnEnd="-1">
        <Text>Datos Generales</Text>
        <Text fontWeight={600} fontSize="1.8em">
          {`${name} ${firstLastName} ${secondLastName}`}
        </Text>
      </View>
      <TextField
        label="Fecha de nacimiento"
        variation="quiet"
        isRequired={false}
        isReadOnly={true}
        value={birth}
        onBlur={() => runValidationTasks("birth", birth)}
        errorMessage={errors.birth?.errorMessage}
        hasError={errors.birth?.hasError}
        {...getOverrideProps(overrides, "birth")}
      ></TextField>
      <TextField
        label="Teléfono de contacto"
        variation="quiet"
        isRequired={true}
        isReadOnly={true}
        type="tel"
        value={phone}
        onBlur={() => runValidationTasks("phone", phone)}
        errorMessage={errors.phone?.errorMessage}
        hasError={errors.phone?.hasError}
        {...getOverrideProps(overrides, "phone")}
      ></TextField>
      <View>
      <TextField
        label="CURP"
        isRequired={false}
        isReadOnly={true}
        variation="quiet"
        value={curp}
        onBlur={() => runValidationTasks("curp", curp)}
        errorMessage={errors.curp?.errorMessage}
        hasError={errors.curp?.hasError}
        {...getOverrideProps(overrides, "curp")}
      ></TextField>
      </View>
      <View>
      <TextField
        label="Correo electrónico"
        isRequired={false}
        isReadOnly={true}
        variation="quiet"
        value={email}
        onBlur={() => runValidationTasks("email", email)}
        errorMessage={errors.email?.errorMessage}
        hasError={errors.email?.hasError}
        {...getOverrideProps(overrides, "email")}
      ></TextField>
      </View>
      <TextField
        label="Código postal"
        variation="quiet"
        isRequired={false}
        isReadOnly={true}
        value={cp}
        onBlur={() => runValidationTasks("cp", cp)}
        errorMessage={errors.cp?.errorMessage}
        hasError={errors.cp?.hasError}
        {...getOverrideProps(overrides, "cp")}
      ></TextField>
      <TextField
        label="Colonia"
        variation="quiet"
        isRequired={false}
        isReadOnly={true}
        value={suburb}
        onBlur={() => runValidationTasks("suburb", suburb)}
        errorMessage={errors.suburb?.errorMessage}
        hasError={errors.suburb?.hasError}
        {...getOverrideProps(overrides, "suburb")}
      >
      </TextField>
      <View columnStart="1" columnEnd="-1">
      <Text fontWeight={600} fontSize="1.2em" marginTop={"20px"} marginBottom={"20px"}>Historial del Lead</Text>
      <TableDetail lead={idProp}/>
      </View>
    </Grid>
  );
}
